import { z } from 'zod';
import { ROLES } from '../roles';
import { requiredText } from './common';

export const loginSchema = z.object({
  email: z.string({ required_error: 'Informe o e-mail' }).trim().toLowerCase().email('E-mail inválido'),
  password: z.string({ required_error: 'Informe a senha' }).min(1, 'Informe a senha').max(200),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const passwordSchema = z
  .string()
  .min(8, 'A senha deve ter pelo menos 8 caracteres')
  .max(128, 'Senha muito longa')
  .refine((v) => /[A-Za-z]/.test(v) && /\d/.test(v), 'Use letras e números na senha');

export const userCreateSchema = z.object({
  name: requiredText(120, 'Nome', 2),
  email: z.string().trim().toLowerCase().email('E-mail inválido'),
  role: z.enum(ROLES, { errorMap: () => ({ message: 'Perfil inválido' }) }),
  password: passwordSchema,
  active: z.boolean().optional(),
});
export type UserCreateInput = z.infer<typeof userCreateSchema>;

export const userUpdateSchema = z.object({
  name: requiredText(120, 'Nome', 2).optional(),
  email: z.string().trim().toLowerCase().email('E-mail inválido').optional(),
  role: z.enum(ROLES).optional(),
  active: z.boolean().optional(),
  password: passwordSchema.optional(),
});
export type UserUpdateInput = z.infer<typeof userUpdateSchema>;

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Informe a senha atual'),
    newPassword: passwordSchema,
  })
  .refine((v) => v.currentPassword !== v.newPassword, {
    message: 'A nova senha deve ser diferente da atual',
    path: ['newPassword'],
  });
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
